import CustomerSection from "./CustomerSection";

export default CustomerSection;
